export default __webpack_public_path__ + "3f6c489e77381bd12f5fe5c739d0bcea.png";